// Site Visit utility functions

export const generateSiteVisitNumber = (visitNumber: number): string => {
  const paddedNumber = String(visitNumber).padStart(4, '0');
  const year = new Date().getFullYear();
  return `LT/${paddedNumber}/${year}`;
};

export const getNextSiteVisitNumber = (existingVisits: any[]): number => {
  if (existingVisits.length === 0) {
    return 1;
  }
  
  const lastVisit = existingVisits[existingVisits.length - 1];
  const lastNo = lastVisit.no;
  
  // Parse the number from LT/XXXX/YYYY format
  const lastNumber = parseInt(lastNo.split('/')[1]);
  return lastNumber + 1;
};
